import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

interface Tab {
  Name: string;
  Data: string; // Pour gerer les séparateur niveau armaor
}

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {

  @ViewChild('TableOverview', { static: false }) mTableOverview!: MatTable<Tab>;

  HTML_img1?: SafeUrl;
  HTML_img2?: SafeUrl;
  HTML_imgDeliveredWeightPerDiameter?: SafeUrl;

  HTML_TableaHeader = ['1', '2'];
  HTML_TableDataSource: MatTableDataSource<Tab> = new MatTableDataSource<Tab>([]);
  HTML_TableTitle = ['', ''];

  constructor(private mHttp: HttpClient,
              private mSanitizer: DomSanitizer,
              private mToolbar: AppToolbarService) {

  }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = 'Vue d\'ensemble';
    this.refreshData();
    this.mToolbar.getObservableSiteChange().subscribe(next => this.refreshData());
  }

  private refreshData() {
    this.loadImgFromServer();
    this.loadTableDataSource();
  }

  loadImgFromServer() {
    ArmaServConnection.getSafeUrlImgFromDatasnap(
      this.mHttp,
      this.mSanitizer,
      'GetOverviewGraphWeight',
      [this.mToolbar.selectedSiteCode]
    ).then(url => this.HTML_img1 = url
    ).catch(e => console.error(e));

    ArmaServConnection.getSafeUrlImgFromDatasnap(
      this.mHttp,
      this.mSanitizer,
      'GetOverviewGraphWeightByMonth',
      [this.mToolbar.selectedSiteCode]
    ).then(url => this.HTML_img2 = url
    ).catch(e => console.error(e));

    ArmaServConnection.getSafeUrlImgFromDatasnap(
      this.mHttp,
      this.mSanitizer,
      'GetOverViewPieDeliveryWeight',
      [this.mToolbar.selectedSiteCode]
    ).then(url => this.HTML_imgDeliveredWeightPerDiameter = url
    ).catch(e => console.error(e));
  }

  async loadTableDataSource() {
    this.HTML_TableDataSource.data = [];
    const arrayOfElement = (await ArmaServConnection.aGET(this.mHttp, 'GetOverviewGrid', [this.mToolbar.selectedSiteCode])).result[0];
    for (let i = 0; i < arrayOfElement.length; i++) {
      const elem = arrayOfElement[i];
      if (i == 0) {
        this.HTML_TableTitle = [elem.Data, elem.Value];
      } else {
        this.HTML_TableDataSource.data.push({
          Name: elem.Data,
          Data: elem.Value
        });
      }
    }
    this.mTableOverview.renderRows(); // Pour actualiser le tableau
  }

}
